/**
 * Router scroll rule (docs/specs/2026-10-07 orders status-tabs design,
 * §11.1, R14). Vue-free so it can be unit-tested; src/routes/router.js passes
 * it as `scrollBehavior`.
 *
 * - back / forward: restore the saved position
 * - a hash: scroll to that element
 * - same path, only the query / params changed (page, tab, filters written to
 *   the URL by the orders pages, /seller/orders, ...): keep the position
 * - anything else (a real page change, first load): go to the top
 */
export function routerScrollBehavior(to, from, savedPosition) {
  if (savedPosition) return savedPosition;
  if (to && to.hash) return { selector: to.hash };
  if (to && from && to.path === from.path) return false;
  return { x: 0, y: 0 };
}

export default routerScrollBehavior;
